import { observer } from 'mobx-react-lite'
import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { useStore } from '../../../lib/context'
import css from 'styled-jsx/css'

const { className, styles } = css.resolve`
	div {
		position: fixed;
		pointer-events: none;

		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: -1;
	}

`

const BackgroundColor = observer(() => {
	const {
		uiStore: { community__activeTab },
	} = useStore()

	const backgroundColor =
		community__activeTab === null ? '#fff' : community__activeTab.color
	return (
		<AnimatePresence>
			<motion.div
				className={className}
				initial={{ backgroundColor: '#fff' }}
				animate={{
					backgroundColor,
				}}
				exit={{ backgroundColor: '#fff' }}
				transition={{ duration: 0.4 }}
			>
				{styles}
			</motion.div>
		</AnimatePresence>
	)
})

export default BackgroundColor
